import { rest } from "msw";
import { apiUrl } from "features/configure";
import { communityAnalysis } from "./data/MockCommunityAnalysis";
const getAnalysisSummary = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/summary`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].summary)
    );
  }
);
const getAnalysisCohort = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/cohort`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(communityAnalysis[reportType].cohort));
  }
);

const getAnalysisMentions = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/mentions`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].mentions)
    );
  }
);
const getAnalysisKeywords = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/keywords`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].keywords)
    );
  }
);

const getAnalysisMessages = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/messages`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].messages)
    );
  }
);
const getAnalysisParticipants = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/participants`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].participants)
    );
  }
);

const getAnalysisReactions = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/reactions`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].reactions)
    );
  }
);
const getAnalysisOverviewEngagements = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/engagements`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis.overview.engagements)
    );
  }
);

const getAnalysisOverviewNewParticipants = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/newParticipants`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis.overview.newParticipants)
    );
  }
);

const getAnalysisOverviewKeywordCloud = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/keywordCloud`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis.overview.keywordCloud)
    );
  }
);

const getAnalysisOverviewKeywordTrend = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:reportType/keywordTrend`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis.overview.keywordTrend)
    );
  }
);

const getTopMemberAnalytics = rest.post(
  `${apiUrl}/api/communityDashboard/:entityName/:platform/topMembers`,
  (req, res, ctx) => {
    const { platform } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[platform].topMembers)
    );
  }
);

const getAnalysisSummarySubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/summary`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].summary)
    );
  }
);
const getAnalysisCohortSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/cohort`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(ctx.status(200), ctx.json(communityAnalysis[reportType].cohort));
  }
);

const getAnalysisMentionsSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/mentions`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].mentions)
    );
  }
);
const getAnalysisKeywordsSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/keywords`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].keywords)
    );
  }
);

const getAnalysisMessagesSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/messages`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].messages)
    );
  }
);
const getAnalysisParticipantsSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/participants`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].participants)
    );
  }
);

const getAnalysisReactionsSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/reactions`,
  (req, res, ctx) => {
    const { reportType } = req.params;
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis[reportType].reactions)
    );
  }
);
const getAnalysisOverviewEngagementsSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/engagements`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis.overview.engagements)
    );
  }
);

const getAnalysisOverviewNewParticipantsSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/newParticipants`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis.overview.newParticipants)
    );
  }
);

const getAnalysisOverviewKeywordCloudSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/keywordCloud`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis.overview.keywordCloud)
    );
  }
);

const getAnalysisOverviewKeywordTrendSubEntity = rest.post(
  `${apiUrl}/apiEvaluate/communityDashboard/:entityName/:subEntityName/:reportType/keywordTrend`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json(communityAnalysis.overview.keywordTrend)
    );
  }
);

const getExcludedKeywords = rest.get(
  `${apiUrl}/api/communityDashboard/:entityName/:platform/getExcludedKeywords`,
  (req, res, ctx) => {
    const { platform } = req.params;
    return res(ctx.status(200), ctx.json([]));
  }
);
const getExcludedUsers = rest.get(
  `${apiUrl}/api/communityDashboard/:entityName/:platform/getExcludedUsers`,
  (req, res, ctx) => {
    const { platform } = req.params;
    return res(ctx.status(200), ctx.json([]));
  }
);

export const communityAnalysisMocks = [
  getAnalysisSummary,
  getAnalysisCohort,
  getAnalysisKeywords,
  getAnalysisParticipants,
  getAnalysisReactions,
  getAnalysisOverviewEngagements,
  getAnalysisOverviewNewParticipants,
  getAnalysisOverviewKeywordCloud,
  getAnalysisMessages,
  getAnalysisOverviewKeywordTrend,
  getAnalysisMentions,
  getTopMemberAnalytics,
  getAnalysisSummarySubEntity,
  getAnalysisCohortSubEntity,
  getAnalysisMentionsSubEntity,
  getAnalysisKeywordsSubEntity,
  getAnalysisMessagesSubEntity,
  getAnalysisParticipantsSubEntity,
  getAnalysisReactionsSubEntity,
  getAnalysisOverviewEngagementsSubEntity,
  getAnalysisOverviewNewParticipantsSubEntity,
  getAnalysisOverviewKeywordCloudSubEntity,
  getAnalysisOverviewKeywordTrendSubEntity,
  getExcludedUsers,
  getExcludedKeywords,
];
